import React from 'react';

const CATEGORIES = [
  { id: 'all', label: 'Todos', emoji: '📍' },
  { id: 'mercado', label: 'Mercado', emoji: '🛒' },
  { id: 'farmacia', label: 'Farmácia', emoji: '💊' },
  { id: 'padaria', label: 'Padaria', emoji: '🥖' },
  { id: 'restaurante', label: 'Restaurante', emoji: '🍽️' },
  { id: 'servicos', label: 'Serviços', emoji: '🔧' },
  { id: 'evento', label: 'Eventos', emoji: '🎉' },
  { id: 'publico', label: 'Público', emoji: '🏛️' },
];

export function CategoryFilter({ active, onChange }) {
  return (
    <div className="nc-cat-filter" role="group" aria-label="Filtrar por categoria">
      {CATEGORIES.map(cat => (
        <button
          key={cat.id}
          type="button"
          className={active === cat.id ? 'nc-cat-filter__item nc-cat-filter__item--active' : 'nc-cat-filter__item'}
          onClick={() => onChange(cat.id)}
          aria-pressed={active === cat.id}
          aria-label={`Filtrar por ${cat.label}`}
        >
          <span className="nc-cat-filter__emoji">{cat.emoji}</span>
          {cat.label}
        </button>
      ))}
    </div>
  );
}
